<template>
  <div class="body_container main_context" ref="windows">
    <div class="input_zone">
      <!-- <div class="next_botton_div">
  <el-button style="margin-left: 10px" size="small" type="primary" plain :disabled="step_num===1?true:false" @click="previousStep()" >
      Previous step
  </el-button>
  <el-button style="margin-left: 10px" size="small" type="primary" plain :disabled="step_num===step_count?true:false" @click="nextStep()" >
      Next step
  </el-button>
      </div>-->
      <el-steps :active="step_num" :align-center="false" class="steps">
        <el-step title="Upload your GWAS summary file" icon="el-icon-upload"></el-step>
        <el-step title="Fill the options" icon="el-icon-edit"></el-step>
        <el-step title="Submitted" icon="el-icon-picture"></el-step>
      </el-steps>
      <div class="steps-context" ref="steps_context">
        <div class="step">
          <el-form ref="form" :model="form" label-width="80px">
            <div class="gwas-tips">
              The GWAS summary file must be a tab or comma delimited text file containing three columns with header line, i.e.,
              chromosome number, base pair postion (based on hg19/38) and P-value.
              The file size cannot exceed 200MB. We strongly recommend you to compress your file
              by <a style="text-decoration:none;color:#409EFF" href="https://www.gzip.org/">gzip</a> to reduce upload time.
              <p style="color:red">The input variants in a GWAS summary file must be full,
                required for a valid gene-based association test. A pre-selection of only significant variants may cause
                false-positive inflation of gene-based association results and unreliable inference of relevant cell types. </p>
              <p style="font-style:italic; font-weight:500;">We promise to keep every user's submitted data private.
                <a style="text-decoration:none;color:#409EFF" href="#/document?id=1-8">Data Privacy Policy</a></p>
            </div>
            <p><span style="font-style:italic; font-weight:550;font-size:14px">Example GWAS summary file format:</span></p>
            <div class="code">
              CHR,BP,P<br>
              1,10000,1e-5<br>
              1,102000,0.09<br>
              2,102000,0.1<br>
              ...<br>
            </div>
            <el-upload class="gwas-upload"
                       :file-list="file_list"
                       :auto-upload="false"
                       drag
                       ref="upload"
                       :on-success="succssUpload"
                       :multiple="false"
                       :limit="1"
                       :show-file-list="true"
                       :before-upload="checkUpload"
                       :on-error="uploadError"
                       :on-progress="uploadProgress"
                       :on-change="changeFile"
                       :on-remove="removeFile"
                       :on-exceed="exceedFile"
                       :action="uploadURL"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drag file to here or
                <em>click to select file</em>
              </div>

            </el-upload>
            <div class="upload_btn">
              <div class="tip_box" v-if="uploadDisable">
                <i class="el-icon-loading"></i> The file is being uploaded.
                <span style="color:red">DO NOT exit or refresh the page. </span>
                The web page will automatically jump to the next step after the file is uploaded successfully.
              </div>
              <a :href="example_gwas"
                 class="primary_link example_a"
                 target="_blank"
              >Example.txt.gz</a>
              <el-button
                type="success"
                @click="submitExample"
                :disabled="exampleUploadDisable"
              >Submit with example file</el-button>
              <el-button
                type="primary"
                @click="submitUpload"
                :disabled="uploadDisable"
              >Upload to server</el-button>
              <!-- 新增：历史文件下拉列表 -->
              <div v-if="showExistingFiles" class="existing-files-selector">
                <el-select
                  v-model="selectedExistingFile"
                  placeholder="Select existing file"
                  @change="onExistingFileSelect"
                  style="margin-right: 10px; width: 200px;"
                >
                  <el-option
                    v-for="file in userFiles"
                    :key="file.raw_file_name"
                    :label="file.raw_file_name"
                    :value="file"
                  >
                    <span style="float: left; margin-right: 5px;">{{ file.raw_file_name }}</span>
                    <span style="float: left; margin-right: 20px;">({{ formatFileSize(file.file_size) }})</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ file.upload_time }}</span>
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form>
        </div>
        <div class="step">
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="280px">
            <i slot="suffix" class="el-icon-question"></i>
            <el-form-item prop="task_label">
                            <span slot="label">
                                <span class="span-box">{{label_tips['task_label']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['task_label']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-input v-model="ruleForm.task_label"></el-input>
            </el-form-item>
            <el-form-item>
                            <span slot="label">
                                <span class="span-box">{{label_tips['bulk_cell']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['bulk_cell']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-checkbox-group v-model="ruleForm.bulk_cell_db" :min="1">
                <el-checkbox
                  v-for="db in bulk_cell_ref_dbs"
                  :key="db.value"
                  :label="db.value"
                >{{ db.text }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                            <span slot="label">
                                <span class="span-box">{{label_tips['single_cell']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['single_cell']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <!-- <el-checkbox-group v-model="ruleForm.single_cell_db" :min="0">
                  <el-checkbox
                      v-for="db in single_cell_ref_dbs"
                      :key="db.value"
                      :label="db.value"
                  >{{ db.text }}</el-checkbox>
              </el-checkbox-group> -->
              <el-select v-model="ruleForm.sc_range" placeholder>
                <el-option
                  v-for="item in sc_range"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
              <span  v-if="ruleForm.sc_range=='auto'">: from Bonferroni corrected P &lt;
                                <el-input v-model="ruleForm.sc_range_fwer" style="width:5em" prop="fwer" :maxlength="10"></el-input>
                                OR Top
                                <el-input-number v-model="ruleForm.sc_range_top_num" @change="handleChange" :min="0" :max="10" style="width:10em"></el-input-number>
                                associated tissues
                            </span>
              <el-cascader v-if="ruleForm.sc_range!='auto'" style="width:35em"
                           v-model="ruleForm.sc_select_organs"
                           :options="sc_organ"
                           :props="{ multiple: true }"
                           :filterable="true"
                           placeholder="Browse and search cell types datasets by sampling source tissues (organs)"
                           collapse-tags
                           @change="chageOrgan"
                           clearable>
              </el-cascader>

            </el-form-item>
            <el-form-item prop="chr">
                            <span slot="label">
                                <span class="span-box">{{label_tips['chr']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['chr']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-select v-model="ruleForm.chr" placeholder>
                <el-option
                  v-for="col in gwas_columns"
                  :key="col"
                  :label="col"
                  :value="col"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="bp">
                            <span slot="label">
                                <span class="span-box">{{label_tips['bp']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['bp']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-select v-model="ruleForm.bp" placeholder>
                <el-option
                  v-for="col in gwas_columns"
                  :key="col"
                  :label="col"
                  :value="col"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="p">
                            <span slot="label">
                                <span class="span-box">{{label_tips['p']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['p']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-select v-model="ruleForm.p" placeholder>
                <el-option
                  v-for="col in gwas_columns"
                  :key="col"
                  :label="col"
                  :value="col"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="ref_genome">
                            <span slot="label">
                                <span class="span-box">{{label_tips['ref']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['ref']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-select v-model="ruleForm.ref_genome" placeholder>
                <el-option
                  v-for="item in genomeVal"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="pop">
                            <span slot="label">
                                <span class="span-box">{{label_tips['pop']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['pop']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-select v-model="ruleForm.pop" placeholder>
                <el-option
                  v-for="item in populationVal"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
                            <span slot="label">
                                <span class="span-box">{{label_tips['multi_test']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['multi_test']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-select v-model="ruleForm.multi_test" placeholder>
                <el-option
                  v-for="item in methodVal"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="fwer">
                            <span slot="label">
                                <span class="span-box">{{label_tips['fwer']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['fwer']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-input v-model="ruleForm.fwer"></el-input>
            </el-form-item>
            <el-form-item prop="max_gene">
                            <span slot="label">
                                <span class="span-box">{{label_tips['max_gene']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['max_gene']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-input v-model="ruleForm.max_gene"></el-input>
            </el-form-item>
            <el-form-item>
                            <span slot="label">
                                <span class="span-box">{{label_tips['mhc']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['mhc']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-select v-model="ruleForm.mhc" placeholder>
                <el-option
                  v-for="item in mhcVal"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
                            <span slot="label">
                                <span class="span-box">{{label_tips['region']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['region']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-select v-model="ruleForm.extend_size" placeholder>
                <el-option
                  v-for="item in gene_regionVal"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item>
                <span slot="label">
                    <span class="span-box">{{label_tips['permutation']['label']}}
                        <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['permutation']['tip']" placement="top">
                            <i class="el-icon-question" />
                        </el-tooltip>
                    </span>
                </span>
                <el-select v-model="ruleForm.permutation" placeholder>
                    <el-option
                        v-for="item in permutationVals"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item
              prop="email"
              label="Email (optional)"
              :rules="[
                                { required: false, message: 'Input your email address and you will be notified when the task is complete.', trigger: 'blur' },
                                { type: 'email', message: 'Please input correct email', trigger: ['blur', 'change'] }
                                ]"
            >
                            <span slot="label">
                                <span class="span-box">{{label_tips['email']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['email']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-button
              type="success"
              @click="fillExampleOptions" :disabled='!with_example'
            >Submit with example options</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled='with_example'>Submit</el-button>
            <el-button @click="resetForm('ruleForm')" :disabled='with_example'>Reset</el-button>
          </el-form>
        </div>
        <div class="step">
          <el-result
            icon="success"
            title="Submit sucessfully"
            subTitle="The task has been sumbitted sucessfully! The task will run about 30 minuters in our server.
          Please click the botton below to check your results."
          >
            <template slot="extra">
              <el-button
                type="primary"
                size="medium"
                @click="goResultLink"
              >Check result</el-button>
            </template>
          </el-result>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios/dist/axios.min";
import { api_dir,backTop,pcga_options_tips } from "@/bus.js";
export default {
  name: "AnalyzePhenotype",
  data() {
    var isNumber = (val) => {
      var regPos = /^\d+(\.\d+)?$/; //非负浮点数
      var regNeg =
        /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (regPos.test(val) || regNeg.test(val)) {
        return true;
      } else {
        return false;
      }
    };
    var checkNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Input a number"));
      }
      if (!isNumber(value)) {
        callback(new Error("Input a number, not characters"));
      } else {
        callback();
      }
    };

    return {
      user_id: null,
      uploadURL: null,
      label_tips:pcga_options_tips,
      with_example:false,
      userFiles: [], // 用户历史文件列表
      selectedExistingFile: null, // 选中的历史文件
      showExistingFiles: false, // 是否显示历史文件下拉框
      step_num: 1,
      step_count: 1,
      example_gwas: "static/resource/example/Example.txt.gz",
      gwas_columns: [],
      ruleForm: {
        task_id: "",
        task_label: "",
        bulk_cell_db: ["gtex"],
        single_cell_db: ["sc_hs"],
        ref_genome: "",
        chr: "",
        bp: "",
        p: "",
        pop: "",
        multi_test: "bhfdr",
        fwer: "0.05",
        mhc: "0",
        extend_size: "5000",
        email:'',
        max_gene:1000,
        sc_range:'auto',
        sc_range_fwer:0.05,
        sc_range_top_num:1,
        sc_select_organs:[],
        permutation:'0',
      },

      go_task_id:'',

      rules: {
        task_label: [{ required: true, message: 'Specify a label for the job', trigger: 'blur' },
          { min: 1, max: 30, message: 'The label length should be in 3-30 characters.', trigger: 'blur' }],
        ref_genome: [{ required: true, message: 'Select reference genome version', trigger: 'change' }],
        chr: [{ required: true, message: 'Select a value', trigger: 'change' }],
        bp: [{ required: true, message: 'Select a value', trigger: 'change' }],
        p: [{ required: true, message: 'Select a value', trigger: 'change' }],
        pop: [{ required: true, message: 'Select a value', trigger: 'change' }],
        fwer: [{ validator: checkNumber, trigger: 'blur' }],
        max_gene:[{ validator: checkNumber, trigger: 'blur' }],
      },

      populationVal: [
        { value: "EUR", text: "EUR (European)" },
        { value: "EAS", text: "EAS (East Asian)" },
        { value: "AFR", text: "AFR (African)" },
        { value: "AMR", text: "AMR (Admixed American)" },
        { value: "SAS", text: "SAS (South Asian)" },
      ],

      genomeVal: [
        { value: "hg19", text: "hg19/GRCh37" },
        { value: "hg38", text: "hg38/GRCh38" },
      ],

      gwasColNames: [
        { name: "chr", text: "Chromosome number column" },
        { name: "bp", text: "Base pair position column" },
        { name: "pvalue", text: "P value column" },
      ],

      bulk_cell_ref_dbs: [
        { value: "gtex", text: "Human tissues (54)" },
      ],
      single_cell_ref_dbs: [
        { value: "sc_hs", text: "Human single cell types (2,214)" },
        { value: "sc_mm", text: "Mouse single cell types (4,384)" },
      ],
      sc_range:[
        { value: "auto", text: "Automatically select" },
        { value: "manual", text: "Manually select" },
      ],
      sc_organ:[],
      methodVal: [
        { text: "Standard Bonferroni correction", value: "bonf" },
        { text: "Benjamini-Hochberg FDR", value: "bhfdr" },
        { text: "Benjamini-Yekutieli FDR", value: "byfdr" },
        { text: "Local FDR", value: "localfdr" },
        { text: "No correction", value: "fixed" },
      ],

      mhcVal: [
        { text: "Yes", value: "1" },
        { text: "No", value: "0" },
      ],
      gene_regionVal: [
        { text: "5kb", value: "5000" },
        { text: "10kb", value: "10000" },
      ],
      permutationVals:[
        { text: "No", value: "0" },
        { text: "Yes", value: "1" },
      ],
      result_url: '',

      github_GWAS: "https://github.com/pmglab/SPA/tree/main/extra",
      uploadDisable:false,
      exampleUploadDisable:false,
      file_list:[],
    };
  },

  mounted: function () {
    this.monitorStep();
    this.getOrganTree();
    this.fetchUserFiles(); // 新增：获取用户历史文件
  },
  watch: {
    step_num: function () {
      this.monitorStep();
      backTop();
    },
    file_list:function(){
      if(this.file_list.length>0){
        this.uploadDisable=true;
      }
    }
  },
  methods: {

    formatFileSize(bytes) {
      // 添加类型检查和转换
      if (bytes === null || bytes === undefined) return '0B';
      // 确保 bytes 是数字类型
      const numBytes = Number(bytes);
      if (numBytes === 0 || isNaN(numBytes)) return '0B';

      const units = ['B', 'KB', 'MB', 'GB'];
      let unitIndex = 0;
      let size = numBytes;

      while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
      }

      return size.toFixed(2) + units[unitIndex];
    },

    getOrCreateUserId() {
      // 从 localStorage 获取用户 ID
      let userId = localStorage.getItem('user_id');
      if (!userId) {
        // 生成新的用户 ID
        userId = 'user_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
        localStorage.setItem('user_id', userId);
      }
      return userId;
    },

    // 新增：获取用户历史文件列表
    fetchUserFiles() {
      var _this = this;
      _this.user_id = this.getOrCreateUserId();
      _this.uploadURL = api_dir+'/api_new.php?action=upload&analyze_type=gwas&user_id='+_this.user_id;
      axios
        .get(api_dir + '/api_new.php?action=get_user_files&user_id=' + _this.user_id)
        .then(function (response) {
          var res = JSON.parse(JSON.stringify(response.data));
          if (Array.isArray(res) && res.length > 0) {
            _this.userFiles = res;
            _this.showExistingFiles = true;
          } else {
            _this.userFiles = [];
            _this.showExistingFiles = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          _this.userFiles = [];
          _this.showExistingFiles = false;
        });
    },

    // 新增：处理选择历史文件
    onExistingFileSelect(file) {
      var _this = this;
      if (file.raw_file_name && file.file_path && file.file_header) {
        axios
          .get(api_dir + "/api_new.php?action=generate_task_id&user_id=" + _this.user_id + "&file_path=" + file.file_path + "&file_size=" + file.file_size)
          .then(function (response) {
            var res = JSON.parse(JSON.stringify(response.data));
            _this.ruleForm.task_id = res['task_id'];
            _this.gwas_columns = file.file_header;
            // 直接跳转到参数设置界面
            _this.step_num = 2;
            _this.$notify({
              title: "File selected",
              message: "Using existing file: " + file.raw_file_name,
              type: "success",
              duration: 2000,
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    submitUpload() {
      this.$refs.upload.submit();
    },
    submitExample(){
      var _this=this;
      axios
        .get(api_dir + "/api.php?action=get_example_id")
        .then(function (response) {
          var res = JSON.parse(JSON.stringify(response.data));
          if(res.error_code==0){
            _this.ruleForm.task_id = res.task_id;
            _this.with_example=true;
            var ruleForm= {
              task_label: "example",
              bulk_cell_db: ["gtex"],
              // single_cell_db: ["sc_hs",'sc_mm'],
              ref_genome: "hg19",
              chr: "CHR",
              bp: "BP",
              p: "P",
              pop: "EUR",
              multi_test: "bhfdr",
              fwer: "0.05",
              mhc: "0",
              extend_size: "5000",
            }
            for(var k in ruleForm){
              _this.$data.ruleForm[k]=ruleForm[k];
            }
            _this.step_num += 1;
          }
        })
        .catch(function (error) {
          console.log(error);
        });

    },

    checkUpload(file){
      const maxFilesize=200*1024*1024;
      if(file.size>maxFilesize){
        this.$refs.upload.clearFiles();
        this.uploadDisable=false;
        this.$notify({
          title: "Check failed",
          message: 'File size cannot exceed 200MB!',
          type: "error",
          duration: 5000,
        });
        return false;
      }else{
        return true;
      }
    },
    uploadError(){
      this.$refs.upload.clearFiles();
      this.uploadDisable=false;
      this.$notify({
        title: "Upload failed",
        message: 'Upload failed! Please check the network!',
        type: "error",
        duration: 5000,
      });
      this.$message.error('');
    },
    uploadProgress(){
      this.uploadDisable=true;
    },
    // 在 methods 中修改 changeFile 方法
    changeFile(file, fileList) {
      // 检查 userFiles 中是否有相同名称和大小的文件
      const matchingFile = this.userFiles.find(f =>
        f.raw_file_name === file.name &&
        parseInt(f.file_size) === file.size
      );

      if (matchingFile) {
        // 找到匹配文件，使用现有文件
        this.$notify({
          title: "File Found",
          message: `File "${file.name}" already exists. Using existing file instead of uploading.`,
          type: "success",
          duration: 3000,
        });
        // 调用现有文件选择方法
        this.onExistingFileSelect(matchingFile);
        // 清除上传的文件列表，避免实际上传
        this.$refs.upload.clearFiles();
        // 重置按钮状态
        this.exampleUploadDisable = false;
        this.uploadDisable = false;
      } else {
        // 没有匹配文件，正常处理
        this.exampleUploadDisable = true;
      }
    },

    removeFile(){
      this.exampleUploadDisable=false;
    },
    exceedFile(){
      this.$notify({
        title: "Only allow one file",
        message: 'Remove existing file before re-selecting another file',
        type: "error",
        duration: 5000,
      });
    },
    succssUpload(res, file, fileList) {
      if ('file_header_error' in res) {
        this.$notify({
          title: "Illegal file",
          message: res['file_header_error'],
          type: "error",
          duration: 5000,
        });
        this.$refs.upload.clearFiles();
        this.uploadDisable=false;
      } else {
        this.uploadDisable=false;
        this.$notify({
          title: "Success",
          message: "Uploaded successfully",
          type: "success",
          duration: 4000,
        });
        this.gwas_columns = res["file_header"];
        this.ruleForm.task_id = res["task_id"];
        this.fetchUserFiles();
        this.step_num += 1;
      }
    },
    nextStep() {
      this.step_num += 1;
    },
    previousStep() {
      this.step_num -= 1;
    },

    monitorStep() {
      var steps = this.$refs.steps_context.children;
      this.step_count = steps.length;
      for (var i = 0; i < steps.length; i++) {
        if (i + 1 == this.step_num) {
          steps[i].style.display = "block";
        } else {
          steps[i].style.display = "none";
        }
      }
    },
    submitForm(formName) {
      if (this.ruleForm.task_id === '') {
        this.$notify({
          title: "Illegal operation",
          message: 'Please upload GWAS summary file',
          type: "error",
          duration: 5000,
        });
        return false;
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var para = {};
            for (var k in this.ruleForm) {
              if (!(k == 'single_cell_db' || k=='bulk_cell_db' || k=='sc_select_organs')) {
                para[k] = this.ruleForm[k];
              }
            };
            para['bulk_cell_db'] = this.ruleForm['bulk_cell_db'].join(",");
            var rna_dbs=['gtex'];
            if(para['sc_range']!='auto'){
              var omp={}
              for(var x of this.ruleForm['sc_select_organs']){
                if(!(x[0] in omp)){
                  omp[x[0]]=[]
                }
                omp[x[0]].push(x[1])
              }
              var ogstr=[]
              for(var k in omp){
                ogstr.push(k+':'+omp[k].join(','))
                rna_dbs.push(k);
              }
              para['sc_organs']=ogstr.join(';')
            }else{
              for(k of ['sc_hs','sc_mm']){
                rna_dbs.push(k)
              }
            }
            para['cell_db']=rna_dbs.join(',');
            var _this = this;
            axios
              .get(api_dir + "/api.php?action=submit_task", {
                params: para,
              })
              .then(function (response) {
                var res = JSON.parse(JSON.stringify(response.data));
                if(res.error_code==0){
                  _this.step_num += 1;
                  _this.ruleForm.task_id = '';
                  _this.$refs.upload.clearFiles();
                  _this.$refs.ruleForm.resetFields();
                  _this.$notify({
                    title: "Success",
                    message: "Submited successfully",
                    type: "success",
                    duration: 2000,
                  });
                  _this.go_task_id = res.task_id;
                }else{
                  _this.$notify({
                    title: "Illegal operation",
                    message: 'No such task_id',
                    type: "error",
                    duration: 5000,
                  });
                  return false;
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          } else {
            return false;
          }
        });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    goResultLink() {
      this.$router.push({path:'/results/phenotype_task?task_id='+this.go_task_id});
    },
    fillExampleOptions(){
      var _this=this;

      axios
        .get(api_dir + "/api.php?action=get_example_id")
        .then(function (response) {
          var res = JSON.parse(JSON.stringify(response.data));
          if(res.error_code==0){
            _this.step_num += 1;
            _this.ruleForm.task_id = '';
            _this.$refs.upload.clearFiles();
            _this.$refs.ruleForm.resetFields();
            _this.$notify({
              title: "Success",
              message: "Submited successfully",
              type: "success",
              duration: 2000,
            });
            _this.go_task_id = res.task_id;
          }else{
            _this.$notify({
              title: "Illegal operation",
              message: 'No such task_id',
              type: "error",
              duration: 5000,
            });
            return false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getOrganTree(){
      var _this=this
      axios
        .get(api_dir + "/api.php?action=cell_source_tissue", {

        }).then(function (response) {
        var res = JSON.parse(JSON.stringify(response.data));
        _this.sc_organ=res
      })
    },
    chageOrgan(){
      // console.log(this.ruleForm.sc_select_organs)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.context_main_body {
  width: 100%;
  min-height: 800px;
}
.example_a{
  padding-right: 20px;
}

.steps{
  margin: 20px 40px;
}
.steps-context{
  margin: 50px 40px;
}

.gwas-upload{
  margin: 30px auto;
}

.gwas-tips{
  line-height: 24px;
  font-size: 16px;
}

.upload_btn{
  margin-top: 20px;
}

.tip_box {
  padding: 15px 20px;
  background-color: #fdf6ec;
  font-size: 15px;
  line-height: 24px;
  margin-bottom: 12px;
}

.step >>> .el-form-item__label{
  font-weight: 550;
  font-size: 15px;
}

.code{
  padding:10px 15px;
  background-color: #FDF6E3;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 13px;
  font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
  line-height: 18px;
}

.existing-files-selector {
  display: inline-block;
  margin-left: 15px;
}

.upload_btn {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 确保在小屏幕上也能正常显示 */
@media (max-width: 768px) {
  .upload_btn {
    flex-direction: column;
    align-items: flex-start;
  }

  .existing-files-selector {
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }

  .existing-files-selector .el-select {
    width: 100%;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/analyze_phenotype.vue